export const getExportPublicUrl = async ({
  apiBase,
  exportId,
  authHeaders,
  parseError,
  fetchImpl = fetch
}) => {
  const response = await fetchImpl(`${apiBase}/exports/${exportId}/public-url`, {
    headers: authHeaders,
    cache: 'no-store'
  })
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  const payload = await response.json()
  const publicUrl = String(payload?.public_url || '').trim()
  let parsedUrl
  try {
    parsedUrl = new URL(publicUrl)
  } catch {
    throw new Error('downloadUrl missing')
  }
  if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
    throw new Error('downloadUrl missing')
  }
  return parsedUrl.toString()
}
